var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layer", { staticClass: "opt_more_g", attrs: { name: "notice" } }, [
    _c("div", { staticClass: "box_opt_menu opt_menu_notice" }, [
      _c("div", { staticClass: "menu_item" }, [
        _c(
          "a",
          {
            staticClass: "link_menu",
            attrs: { href: "javascript:" },
            on: {
              click: function ($event) {
                return _vm.callback("F")
              },
            },
          },
          [_vm._v("게시판 공지로 지정")]
        ),
      ]),
      _vm._v(" "),
      _vm.isAdmin
        ? _c("div", { staticClass: "menu_item" }, [
            _c(
              "a",
              {
                staticClass: "link_menu",
                attrs: { href: "javascript:" },
                on: {
                  click: function ($event) {
                    return _vm.callback("H")
                  },
                },
              },
              [_vm._v("전체 공지로 지정")]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }